import React from 'react';
import Pagination from 'src/shared/components/pagination/Pagination';
import styles from './TablePagination.module.scss';
import useDataTable from '../../hooks/useDataTable';

const TablePagination = () => {
    const { setPageNumber, currentPageNumber, filteredRows, rowsPerPage, rows, compactPagination } = useDataTable();

    if (rowsPerPage > rows.length) {
        return null;
    }
    // Counts follow the rows actually on show, so a search that narrows the list
    // reports its matches rather than the unfiltered total.
    const displayedRowsCount = filteredRows.length;
    const lastPageNumber = Math.ceil(displayedRowsCount / rowsPerPage) || 1;
    const firstRowOnPage = displayedRowsCount === 0 ? 0 : (currentPageNumber - 1) * rowsPerPage + 1;
    const lastRowOnPage = Math.min(currentPageNumber * rowsPerPage, displayedRowsCount);

    return (
        <div className={styles.tableControls}>
            <span className={styles.rowsLabel}>
                {compactPagination ? '' : 'Viewing rows '}
                {firstRowOnPage}
                {compactPagination ? '\u2013' : ' - '}
                {lastRowOnPage} of {displayedRowsCount}
            </span>
            <Pagination
                onChange={setPageNumber}
                currentPageNumber={currentPageNumber}
                lastPageNumber={lastPageNumber}
                className={compactPagination ? '!pl-3' : undefined}
            />
        </div>
    );
};

export default TablePagination;
